var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-homework-custom-page",class:{
    'electron-homework-custom-page': _vm.isElectron,
  }},[_c('div',[_c('homework-detail',{attrs:{"workInfo":_vm.workInfo,"questionInfo":_vm.questionInfo}}),_c('my-work-info',{attrs:{"workInfo":_vm.workInfo,"questionInfo":_vm.questionInfo},on:{"updateWorkInfo":_vm.handleUpdateWorkInfo,"updateOnlyTeacherLook":_vm.handleUpdateOnlyTeacherLook}}),_c('classmate-homework')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }